<template>
  <div class="UserPackage-list-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-dropdown
          id="dropdown-right dropdown-form"
          class="dropdown-form-filter"
          no-caret
          right
        >
          <template #button-content>
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </template>
          <h6 class="d-flex align-items-center mb-0 p-4">
            <span class="svg-icon mr-3">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </h6>
          <b-dropdown-divider> </b-dropdown-divider>
          <b-dropdown-form>
            <b-container class="p-0">
              <b-row>
                <b-col cols="4">
                  <basic-input
                    label="Tên người dùng"
                    placeholder="Nhập tên người dùng"
                    name="name"
                    :value.sync="filter.name"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="4">
                  <basic-input
                    label="Tên Coach"
                    placeholder="Nhập tên Coach"
                    name="name"
                    :value.sync="filter.coach"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="4">
                  <basic-input
                    label="Số điện thoại"
                    placeholder="Số điện thoại"
                    name="name"
                    :value.sync="filter.phoneNumber"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="4">
                  <basic-date-picker
                    :value.sync="filter.startDate"
                    label="Ngày tạo UserPackage"
                    placeholder="Ngày tạo UserPackage"
                    name="startDate"
                    data-vv-As="Ngày tạo UserPackage"
                    format="YYYY-MM-DD"
                  />
                </b-col>
                <b-col cols="4">
                  <basic-input
                    label="Số lượng Service Package"
                    placeholder="Nhập số lượng Service Package"
                    name="name"
                    :value.sync="filter.servicePackageCount"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="4">
                  <basic-select
                    label="Service Package"
                    placeholder="Chọn Service Package"
                    name="status"
                    :options="servicePackages"
                    :value.sync="filter.servicePackage"
                    track-by="value"
                    value-label="text"
                    data-vv-as="Trạng thái"
                  ></basic-select>
                </b-col>
                <b-col cols="4">
                  <basic-select
                    label="Program"
                    placeholder="Chọn Program"
                    name="status"
                    :options="programs"
                    :value.sync="filter.program"
                    track-by="value"
                    value-label="text"
                    data-vv-as="Trạng thái"
                  ></basic-select>
                </b-col>
                <b-col cols="4">
                  <basic-select
                    label="Module"
                    placeholder="Chọn Module"
                    name="status"
                    :options="modules"
                    :value.sync="filter.module"
                    track-by="value"
                    value-label="text"
                    data-vv-as="Trạng thái"
                  ></basic-select>
                </b-col>
                <b-col cols="4">
                  <basic-select
                    label="Trạng thái"
                    placeholder="Chọn trạng thái"
                    name="status"
                    :options="status"
                    :value.sync="filter.status"
                    track-by="value"
                    value-label="text"
                    data-vv-as="Trạng thái"
                  ></basic-select>
                </b-col>
              </b-row>
            </b-container>
          </b-dropdown-form>
          <b-dropdown-divider> </b-dropdown-divider>
          <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="resetRequest"
            >
              <span class="svg-icon">
                <inline-svg
                  src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                />
              </span>
              Reset bộ lọc
            </b-button>
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="searchRequest"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Lọc dữ liệu
            </b-button>
          </div>
        </b-dropdown>
        <!-- <b-button
          class="btn btn-success ml-2"
          type="button"
          @click="createItem"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Thêm mới
        </b-button> -->
        <!-- <b-button v-if="isDeletePermission" class="btn btn-success ml-2" type="button"
          @click="importItems">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/upload-cloud.svg" />
          </span>
          Import
        </b-button> -->
        <!-- <modal-import @import-success="loadData(true)" /> -->
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="UserPackage-list-page__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :selectAction="false"
                  :searchAction="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item }">
                    <td>
                      {{ item.userName }}
                    </td>
                    <td>
                      {{ item.coachName }}
                    </td>
                    <td
                      class="text-center"
                      :class="getPositionClass(item.level)"
                    >
                      {{ item.level }}
                    </td>
                    <td class="text-center">
                      {{ item.servicePackageCount }}
                    </td>
                    <!-- <td :class="getPositionClass(item.saleMoney)">
                      {{ item.saleMoney }}
                    </td> -->

                    <td class="text-center">
                      {{ convertTimestampToDate(item.startDate) }}
                    </td>
                    <!-- <td :class="getPositionClass(item.endDate)">
                      {{ convertTimestampToDate(item.endDate) }}
                    </td> -->
                    <td class="text-center">
                      {{ item.phoneNumber }}
                    </td>

                    <td class="text-center">
                      <div class="status" :class="getStatus(item.status)">
                        {{ statusText(item.status) }}
                      </div>
                    </td>
                    <td>
                      <action-dropdown
                        :value="item"
                        :show_edit="false"
                        :show_delete="false"
                        :show_copy="false"
                        :show_view="true"
                        :boundary="data.length > 2 ? 'scrollParent' : 'window'"
                        @view="viewItem"
                      >
                        <b-dropdown-text
                          v-if="isDeletePermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="deleteItem(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm"
                              :class="
                                item.status ? 'text-primary' : 'text-danger'
                              "
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/power.svg"
                              />
                            </span>
                            <span
                              class="success navi-text"
                              :class="
                                item.status ? 'text-primary' : 'text-danger'
                              "
                            >
                              {{
                                item.status ? 'Hoạt động' : 'Không hoạt động'
                              }}
                            </span>
                          </a>
                        </b-dropdown-text>
                      </action-dropdown>
                    </td>
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { TAG_TYPE } from '../../../core/plugins/constants';
import moment from 'moment';
export default {
  props: {},
  name: 'TranUserPackageList',

  data() {
    return {
      levels: [
        {
          text: 'Level 0',
          value: 0,
        },
        {
          text: 'Level 1',
          value: 1,
        },
        {
          text: 'Level 2',
          value: 2,
        },
        {
          text: 'Level 3',
          value: 3,
        },
        {
          text: 'Level 4',
          value: 4,
        },
      ],
      status: [
        {
          value: 0,
          text: 'Hoạt động',
        },
        {
          value: 1,
          text: 'Không hoạt động',
        },
      ],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      filter: {
        code: null,
        name: null,
        level: null,
        servicePackages: null,
        program: null,
        module: null,
        status: null,
        startDate: null,
        phoneNumber: null,
        coach: null,
        servicePackageCount: null,
      },
      sort: {
        by: null,
        order: null,
      },
      column: [
        {
          key: 'nameUser',
          label: 'Khách',
          sortable: false,
          style: 'width: 15%',
        },
        {
          key: 'nameCoach',
          label: 'Coach',
          sortable: false,
          style: 'width: 15%',
        },
        {
          key: 'level',
          label: 'Cấp độ',
          sortable: false,
          style: 'width: 10%',
          class: 'text-center',
        },
        {
          key: 'servicePackageCount',
          label: 'Số lượng gói đăng ký',
          sortable: false,
          style: 'width: 15%',
          class: 'text-center',
        },
        // {
        //   key: 'saleMoney',
        //   label: 'Giá tiền',
        //   sortable: false,
        //   style: 'width: 10%',
        // },
        {
          key: 'startDate',
          label: 'Ngày bắt đầu',
          sortable: false,
          style: 'width: 10%',
          class: 'text-center',
        },
        // {
        //   key: 'endDate',
        //   label: 'Ngày kết thúc',
        //   sortable: false,
        //   style: 'width: 10%',
        // },
        {
          key: 'accountId',
          label: 'Số điện thoại',
          sortable: false,
          style: 'width: 10%',
          class: 'text-center',
        },

        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          style: 'width: 10%',
          class: 'text-center',
        },
        {
          key: 'action',
          label: '',
          sortable: false,
          style: 'width: 5%',
        },
      ],
      data: [],
      loading: false,
      servicePackages: [],
      programs: [],
      modules: [],
      selectedItems: [],
      packageData: [],
    };
  },
  computed: {

    searchParams() {
      const payload = this.removeEmpty({
        userName: this.filter.name,
        level: this.filter.level,
        servicePackageId: this.filter.servicePackage,
        status: this.filter.status,
        startDate: this.convertDateToTimestamp(this.filter.startDate),
        coachName: this.filter.coach,
        programId: this.filter.program,
        moduleId: this.filter.module,
        servicePackageCount: this.filter.servicePackageCount,
        phoneNumber: this.filter.phoneNumber,

        page: this.paging.page,
        size: this.paging.pageSize,
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }
      return params;
    },

    phoneNumbers() {
      const cache = {};
      return this.items.reduce((acc, item) => {
        acc[item.accountId] =
          cache[item.accountId] || this.fetchPhoneNumber(item.accountId);
        return acc;
      }, {});
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
  },
  methods: {
    convertDateToTimestamp(date) {
      if (!date) return null;
      return Math.floor(new Date(date).getTime() / 1000);
    },
    convertTimestampToDate(timestamp) {
      return timestamp ? moment(timestamp * 1000).format('DD/MM/YYYY') : null;
    },
    searchRequest() {
      this.loadData();
      document.body.click();
    },
    resetRequest() {
      this.filter.name = null;
      this.filter.coach = null;
      this.filter.phoneNumber = null;
      this.filter.level = null;
      this.filter.servicePackage = null;
      this.filter.program = null;
      this.filter.module = null;
      this.filter.status = null;
      this.filter.startDate = null;
      this.filter.servicePackageCount = null;
      this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      this.sort = {
        by: sortData.column,
        order: sortData.order,
      };
      this.loadData();
    },
    viewItem(item) {
      this.$router.push({
        name: 'tran_user_package_view',
        params: {
          id: item.accountId,
        },
      });
    },
    editItem(item) {
      this.$router.push({
        name: 'tran_user_package_view',
        params: {
          id: item.accountId,
          form_type: 'edit',
        },
      });
    },
    getPositionClass(value) {
      if (typeof value === 'number' && !isNaN(value)) {
        return 'text-left'; // Number
      } else if (typeof value === 'string') {
        return 'text-left'; // String
      } else if (
        (Object.prototype.toString.call(value) === '[object Date]' &&
          !isNaN(value)) ||
        !isNaN(Date.parse(value))
      ) {
        return 'text-left'; // Date or DateTime
      } else {
        return 'text-left'; // Unidentified
      }
    },
    createItem() {
      this.$router.push({
        name: 'user_package_edit',
        params: {
          form_type: 'create',
        },
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        this.veeFields[ref].dirty &&
        this.veeFields[ref].validated
      ) {
        return this.veeFields[ref].valid;
      }
      return null;
    },

    deleteItem(item) {
      let btn = item.status == 0 ? 'btn-active' : 'btn-inactive';
      let textStatusB = item.status ? 'Hoạt động' : 'Không hoạt động';
      let textStatusA = !item.status ? 'Hoạt động' : 'Không hoạt động';
      this.$swal({
        title: '',
        text: `Bạn có chắc chắn muốn chuyển trạng thái ${textStatusB} thành ${textStatusA} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Hủy',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: 'Chắc chắn',
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.changeStatus(item);
          }
        }.bind(this),
      );
    },

    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);
      const formData = new FormData();

      formData.append('status', item.status ? '0' : '1');

      const res = await this.$api.put(
        `/UserPackage/ReActive/${item.id}`,
        formData,
      );

      const { error } = res;
      if (error) {
        if (error.message) {
          this.$store.commit('context/setLoading', false);
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
      }
      this.$toastr.s({
        title: 'Thành công !',
        msg: 'Cập nhật thành công',
      });
      this.$store.commit('context/setLoading', false);
      this.loadData();
    },
    async loadData() {
      try {
        this.$store.commit('context/setLoading', true);
        const [res] = await Promise.all([
          this.$api.get('TranUserPackage', {
            params: this.searchParams,
          }),
        ]);
        const { data } = res;

        this.data = data.items || [];
        this.paging.total = data.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    getDataHospital(tags) {
      if (!tags || !tags.length) return null;
      const agencies = tags.filter((el) => el.tag.type === TAG_TYPE.AGENCY);
      return agencies.map((el) => el.tag.name).join(', ');
    },
    // 0 = hoạt động, 1 = không hoạt động, 3 = nháp (gói AI Mode chưa xong).
    //
    // Màn này đọc cùng bảng user_package với màn danh sách gói. BE đã lọc nháp ra
    // khỏi đây, nhưng nhãn vẫn phải đúng — đọc theo kiểu truthy thì 3 bị gọi thành
    // "không hoạt động", và chỉ cần một bản BE chưa kịp build là sai hiện ra ngay.
    // 0 = hoạt động, 1 = không hoạt động, 3 = nháp (gói AI Mode chưa xong).
    // Ép số vì giá trị đi qua JSON có thể về dạng chuỗi.
    toStatusCode(status) {
      return status === null || status === undefined || status === ''
        ? null
        : Number(status);
    },
    isDraft(status) {
      return this.toStatusCode(status) === 3;
    },
    statusText(status) {
      const code = this.toStatusCode(status);
      if (code === 3) return 'Nháp';
      return code ? 'Không hoạt động' : 'Hoạt động';
    },
    getStatus(status) {
      const code = this.toStatusCode(status);
      if (code === 3) return 'draft';
      return code ? 'inactive' : 'active';
    },
    searchDebounce(value) {
      this.filter.searchText = value;
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },

    async getServicePackage() {
      try {
        this.$store.commit('context/setLoading', true);
        const { data } = await this.$api.get('/ServicePackage?status=0&size=1000');
        this.servicePackages = data.items.map((item) => ({
          value: item.id,
          text: item.name,
        }));
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    async getProgram() {
      try {
        this.$store.commit('context/setLoading', true);
        const { data } = await this.$api.get('/Program?status=0&size=1000');
        this.programs = data.items.map((item) => ({
          value: item.id,
          text: item.name,
        }));
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    async getModule() {
      try {
        this.$store.commit('context/setLoading', true);
        const { data } = await this.$api.get('/ProgramModule?status=0&size=1000');
        this.modules = data.items.map((item) => ({
          value: item.id,
          text: item.name,
        }));
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
  },
  async created() {
    await Promise.all([
      this.loadData(),
      this.getServicePackage(),
      this.getProgram(),
      this.getModule(),
    ]);
  },
};
</script>
<style lang="scss" scoped>
.status.draft {
  color: #8950fc;
  background-color: #eee5ff;
}

.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 160px;
  text-align: center;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #ff5756;
  }
}

.text-center {
  text-align: left;
  text-overflow: ellipsis;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 850px;
    }
  }
}

.search-input {
  min-width: 220px;
}
</style>
